import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SquareLockFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.5 6.5C6.5 3.46243 8.96243 1 12 1C15.0376 1 17.5 3.46243 17.5 6.5V9C17.5 9.55228 17.0523 10 16.5 10C15.9477 10 15.5 9.55228 15.5 9V6.5C15.5 4.567 13.933 3 12 3C10.067 3 8.5 4.567 8.5 6.5V9C8.5 9.55228 8.05228 10 7.5 10C6.94772 10 6.5 9.55228 6.5 9V6.5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 8.25C4.48112 8.25 3.24986 9.48137 3.25 11.0003L3.25083 20.0003C3.25097 21.5189 4.48215 22.75 6.00083 22.75H17.9998C19.5186 22.75 20.7498 21.5188 20.7498 20V11C20.7498 9.48122 19.5186 8.25 17.9998 8.25H6ZM13 14.5C13 13.9477 12.5523 13.5 12 13.5C11.4477 13.5 11 13.9477 11 14.5V16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5V14.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SquareLockFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SquareLockFilledIcon;
